// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_Qqv","cls2":"ExportFormatModal-cls2_vmu ExportFormatModal-cls1_Qqv"};